import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ConfigurationService, PathsService } from '@draeger-academy/common';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'da-simple-navigation',
    templateUrl: './simple-navigation.component.html',
    styleUrls: ['./simple-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SimpleNavigationComponent implements OnInit, OnDestroy {
    public homePath: string;
    public language: string;
    public showCoursesOverview: boolean;
    public showContactUs = false;
    public showTrainingAdvisor = false;
    public site: string;
    private _$showSearch: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showSearch$(): Observable<boolean> {
        return this._$showSearch.asObservable();
    }

    private _$showCart: BehaviorSubject<boolean> = new BehaviorSubject(false);
    linkCourseOverview: any;
    linkTrainingAdvisor: any;
    linkContact: any;
    linkCheckout: any;
    public get showCart$(): Observable<boolean> {
        return this._$showCart.asObservable();
    }

    private _$showContact: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showContact$(): Observable<boolean> {
        return this._$showContact.asObservable();
    }

    constructor(
        private _configurationService: ConfigurationService,
        private translate: TranslateService,
        private _pathsService: PathsService,
        private _localizeRouterService: LocalizeRouterService
    ) {
        translate.get('routes.home').subscribe((res: string) => {
            this.homePath = res;
        });

        translate.get('language').subscribe((res: string) => {
            this.language = res;
        });

        translate.get('routes.courses').subscribe((res: string) => {
            if (res && res !== 'routes.courses') {
                this.showCoursesOverview = true;
            }
        });
        translate.get('routes.training-advisor').subscribe((res: string) => {
            if (res && res !== 'routes.training-advisor') {
                this.showTrainingAdvisor = true;
            }
        });
        translate.get('routes.contact-us').subscribe((res: string) => {
            if (res && res !== 'routes.contact-us') {
                this.showContactUs = true;
            }
        });
    }

    ngOnDestroy(): void {}

    ngOnInit(): void {
        this.linkTrainingAdvisor = this._pathsService.getTrainingAdvisorLink();
        this.linkContact = this._pathsService.getContactLink();
        this.getCourseOverviewLink();
        this.getCheckoutLink();

        const _isPortal = this._configurationService.isPartnerPage();

        this.homePath = this.language + this.homePath + '#contact';
        if (this._configurationService.hasFeature('Search')) this._$showSearch.next(true);
        this._$showContact.next(this._configurationService.hasFeature('ShowContactHeader'));

        this._configurationService.portalVersion$.subscribe((portalVersion) => {
            if (portalVersion) {
                this._$showCart.next(portalVersion === 'v2');
            } else {
                if (this._configurationService.hasFeature('ShoppingCart') && !_isPortal) {
                    this.translate.get('routes.checkout').subscribe((res: string) => {
                        if (res && res !== 'routes.checkout') {
                            this._$showCart.next(true);
                        }
                    });
                }
            }
        });
        let site = this._configurationService.getSiteFromUrl();
        if (site) {
            site = this._configurationService.getSiteFromUrl().site;
            this.site = site;
        }
    }

    scrollToContact() {
        setTimeout(function () {
            let hash = window.location.hash;
            if (hash == '#contact') {
                let el = document.getElementById('contact-us');
                let top = el.offsetTop + 300; //Getting Y of target element
                window.scrollTo(0, top);
            }
        }, 500);
    }

    private getCheckoutLink() {
        const _isPortal = this._configurationService.isPartnerPage();

        if (_isPortal) {
            this._configurationService.currentPortal$.subscribe((portalId) => {
                this.linkCheckout = '/partner/' + portalId + '/order-process';
            });
        } else {
            this.linkCheckout = this._localizeRouterService.translateRoute('/checkout');
        }
    }

    private getCourseOverviewLink() {
        const _isPortal = this._configurationService.isPartnerPage();

        if (_isPortal) {
            this._configurationService.currentPortal$.subscribe((portalId) => {
                this.linkCourseOverview = '/partner/' + portalId;
            });
        } else {
            this.linkCourseOverview = this._localizeRouterService.translateRoute('/courses');
        }
    }
}
